import CogWithCrack from '@motional/inguitiv/svg/icon/cog-with-crack.svg?react';

function Icon() {
  return <CogWithCrack />;
}

export default Icon;
